import { render, staticRenderFns } from "./NoteMenu.vue?vue&type=template&id=33a89799&"
import script from "./NoteMenu.vue?vue&type=script&lang=ts&"
export * from "./NoteMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports